import PrimaryButton from '../../core/PrimaryButton';
import TitledTextField from '../../core/TitledTextField';
import { MAX_TITLE_LENGTH } from '../../core/utils/constants';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import CancelButton from '../../core/CancelButton';
import { globalStyles } from '../../core/style/gstheme';

const styles = Object.assign({}, globalStyles);

class AddTemplateDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            title: ""
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    addTemplate = () => {
        this.props.onAddTemplate(this.state.title.trim());
        this.exitAddTemplate();
    };

    exitAddTemplate = () => this.setState({ open: false, title: "" });

    handleChange = event => {
        const t = event.target;
        this.setState({ [t.name]: t.value.trimLeft() });
    };

    render() {

        const { classes, defaultLang } = this.props;
        const { title } = this.state;

        return (
            <React.Fragment>
                <AddButton dataTest="add-template" onClick={() => this.handleClickOpen()} title="Add a template" />
                <Dialog
                    data-test="add-template-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitAddTemplate}
                    aria-labelledby="add-template-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="add-template-dialog-title">Add Template</DialogTitle>
                    <DialogContent style={{ height: 140, overflow: 'visible' }}>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="title"
                                name="title"
                                title="Title"
                                autoFocus={true}
                                required={true}
                                text={title}
                                placeholder="Enter title"
                                maxLength={MAX_TITLE_LENGTH}
                                lang={defaultLang}
                                onChange={this.handleChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddTemplate} />
                        <PrimaryButton disabled={title.length === 0} onClick={this.addTemplate}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

AddTemplateDialog.defaultProps = {
};

AddTemplateDialog.propTypes = {
    classes: PropTypes.object,
    onAddTemplate: PropTypes.func.isRequired,
    viewLang: PropTypes.string,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(AddTemplateDialog);